import copy from '~/assets/icons/copy.svg';
import { CurrencyIcon } from '~/components/collections/CurrencyIcon';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency, formatTime, WalletType } from '~/shared';
import { maskCardNumber } from '~/utils/cardNumber';
import {
	StyledBalanceValue,
	StyledBottomContainer,
	StyledCardNumberContainer,
	StyledContainer,
	StyledCopyButton,
	StyledTopContainer,
} from './AppBankCards.styled';

const AppBankCards = ({ compact }: { compact?: boolean }) => {
	const bankBalance = useObservable(rage.bank.getBalance(WalletType.Bank));
	const cardNumber = useObservable(rage.bank.getCardNumber());
	const bankStats = useObservable(rage.bank.getBankStats());
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleCopyCardNumber = () => {
		rage.input.copyToClipboard(cardNumber);
		rage.notifications.showInfo('Номер карты скопирован');
	};

	return (
		<StyledContainer $compact={compact}>
			<StyledTopContainer>
				<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.5 }}>
					Карта RUB
				</Text>
				<StyledBalanceValue>
					<Text>{bankBalance.toLocaleString('ru-RU')}</Text>
					<CurrencyIcon icon={rubleIcon} size="md" />
				</StyledBalanceValue>
			</StyledTopContainer>
			{!compact && (
				<StyledBottomContainer>
					<StyledCardNumberContainer onClick={handleCopyCardNumber}>
						<Text style={{ fontWeight: 500 }}>
							{maskCardNumber(cardNumber)}
						</Text>
						<StyledCopyButton>
							<img src={copy} width={14} height={14} />
						</StyledCopyButton>
					</StyledCardNumberContainer>
					<Text style={{ textAlign: 'right' }}>
						{formatTime(bankStats.cardExpiresAt, '{MM} / {yy}', {
							useMoscowTimezone: true,
						})}
					</Text>
				</StyledBottomContainer>
			)}
		</StyledContainer>
	);
};

export { AppBankCards };
